import { useState } from "react";
import { Form, Modal } from "react-bootstrap";

export function TransferFromASC({
  prepareASCData,
  uploadASCFile,
  showASCDialog,
  closeDialog
}) {
  const [ASCFile, setASCFile] = useState();

  return (
    <Modal
      show={showASCDialog}
      onHide={closeDialog}
      aria-labelledby="transfer-form-asc-title"
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="transfer-form-asc-title">ASC Programından Aktar</Modal.Title>
      </Modal.Header>

      <Form onSubmit={e => {
        e.preventDefault();
        uploadASCFile(ASCFile);
      }}>
        <Modal.Body>
          <ul>
            <li>Öncelikle Eduwiser'da sınıf, ders ve öğretmen bilgileri tanımlanır.</li>
            <li>Daha sonra bu bilgileri Eduwiser'dan ASC'ye aktarmak için ASC Veri Dosyası oluştur butonu tıklanarak ASC veri dosyası oluşturulur.</li>
            <li>Oluşturulan bu dosya ASC üzerinden aktarılır.</li>
            <li>ASC'de ders programı hazırlanır.</li>
            <li>Ders programı hazırlandıktan sonra bu sefer ders programı ASC'den XML olarak dosyaya aktarılır.</li>
            <li>Aktarılan dosya seçilip ASC verilerini yükle butonuna tıklanarak Eduwiser'a yüklenir.</li>
          </ul>  
          <hr />

          <div className="text-center mb-5">
            <b style={{color: "red"}}>- ASC Veri Dosyası Oluşturma -</b>
            <br /><br />
            <button
              type="button"
              className="btn btn-sm btn-info"
              onClick={prepareASCData}
            >
              Veri Dosyası Oluştur
            </button>
          </div>
          <hr />

          <div className="text-center mt-5">
            <b style={{color: "red"}}>- ASC Veri Dosyasını Yükleme -</b>
            <br /><br />
            <input type="file" accept=".xml" onChange={e => setASCFile(e.target.files[0])} />
          </div>          
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="submit"
            className="btn btn-primary"
          >
            Aktar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={closeDialog}
          >
            Vazgeç
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}